// ════════════════════════════════════════
// app/courses/fitness.tsx
// ════════════════════════════════════════
import { CourseCategoryPage } from '@/components/seo/CourseCategoryPage';
export default function FitnessPage() {
  return (
    <CourseCategoryPage
      config={{
        title: 'קורס כושר ואימון גופני',
        metaTitle: 'קורס כושר ואימון גופני 2025 – מאמן כושר, פילאטיס, יוגה | Kursi',
        slug: 'fitness',
        metaDescription: 'קורסי כושר ואימון גופני 2025 – הכשרת מאמן כושר, פילאטיס, יוגה, קליסטניקס. מדריך לבחירת קורס כושר עם הסמכה מוכרת. קבלו 3 המלצות אישיות.',
        subtitle: 'הכשרת מאמני כושר, פילאטיס, יוגה, קליסטניקס וכושר קרבי — מצאו קורס שיביא אתכם לתוצאות.',
        chips: ['מאמן כושר', 'פילאטיס', 'יוגה', 'קליסטניקס', 'כושר קרבי', 'הכנה לצבא'],
        chatSeed: 'קורס כושר ואימון גופני',
        sections: [
          {
            id: 'goal',
            title: 'לאמן אחרים או לשפר את עצמכם?',
            body: 'יש הבדל גדול בין קורסי הכשרת מאמנים מקצועיים לבין קורסי אימון אישי. מאמנים לומדים אנטומיה, פיזיולוגיה ותכנות אימונים. אימון אישי מתמקד בשיטה ספציפית.',
            bullets: [
              'הכשרת מאמן כושר מוסמך (וינגייט, מע"מ)',
              'מדריך פילאטיס מוסמך',
              'מדריך יוגה — RYT 200/500',
              'קליסטניקס: אימון משקל גוף',
              'כושר קרבי ואומנויות לחימה',
            ],
          },
          {
            id: 'cert',
            title: 'הסמכות מוכרות — חובה למאמנים',
            body: 'מאמני כושר ללא הסמכה מוכרת לא יכולים לעבוד בחדרי כושר מכובדים ולא מכוסים בביטוח מקצועי. בדקו שהקורס מוביל להסמכה מוכרת.',
            bullets: [
              'וינגייט: ההסמכה המוכרת ביותר בישראל',
              'מע"מ (מכון עציון): מוכר ונגיש',
              'Pilates Method Alliance: לפילאטיס',
              'Yoga Alliance: RYT 200 לסטנדרט בינלאומי',
            ],
          },
          {
            id: 'practical',
            title: 'כמה שיותר תרגול מעשי',
            body: 'כושר לומדים בגוף, לא בספר. קורס טוב כולל שעות תרגול, פרקטיקום עם מתאמנים אמיתיים וליווי בשטח.',
            bullets: [
              'פרקטיקום: אימון מתאמנים אמיתיים',
              'ניתוח תנועה ותיקון שגיאות',
              'תכנות אימונים לסוגי לקוחות שונים',
              'תזונה בסיסית לספורטאים',
            ],
          },
        ],
        checklist: [
          'ההסמכה מוכרת (וינגייט / מע"מ / Yoga Alliance)',
          'יש חלק מעשי עם מתאמנים אמיתיים',
          'מכסה אנטומיה ופיזיולוגיה',
          'יש ליווי אחרי הקורס להשמה',
          'המרצים עם ניסיון שטח פעיל',
        ],
        redFlags: [
          'הכשרה ללא הסמכה מוכרת',
          'קורס ללא חלק מעשי',
          'הבטחות גוף מושלם ב-30 יום',
          'אין תוכן אנטומיה / פיזיולוגיה',
        ],
        faq: [
          { q: 'כמה זמן לוקחת הכשרת מאמן כושר?', a: '3–12 חודשים תלוי בסוג ההסמכה. קורסים מקוצרים 3 חודשים, תכניות מלאות (וינגייט) 6–12 חודשים.' },
          { q: 'כמה מרוויח מאמן כושר?', a: 'מאמן בחדר כושר: 8,000–15,000₪. מאמן אישי עצמאי: 15,000–35,000₪. תלוי בלקוחות ובמוניטין.' },
          { q: 'האם אפשר לעבוד בלי הסמכה?', a: 'טכנית אפשרי, אבל ביטוח מקצועי וחדרי כושר מכובדים דורשים הסמכה. גם מקצועית — ההסמכה נותנת ידע בסיסי חיוני.' },
        ],
      }}
    />
  );
}

// ════════════════════════════════════════
// app/courses/beauty.tsx
// ════════════════════════════════════════
export function BeautyPage() {
  return (
    <CourseCategoryPage
      config={{
        title: 'קורס ביוטי, מניקור, ספרות וטיפוח',
        metaTitle: 'קורס ביוטי ומניקור 2025 – ספרות, ריסים, פדיקור | Kursi',
        subtitle: 'מניקור, פדיקור, ספרות, הדבקת ריסים ועיצוב גבות — קורסי יופי מקצועיים לכל התמחות.',
        chips: ['מניקור', 'ספרות', 'ריסים', 'גבות', 'פדיקור', 'ביוטי'],
        chatSeed: 'קורס ביוטי ומניקור',
        sections: [
          {
            id: 'specialization',
            title: 'בחרו התמחות',
            body: 'תחום הביוטי מתחלק להתמחויות שונות. כל אחת דורשת ציוד, הכשרה וקהל לקוחות שונה. מומלץ להתחיל בהתמחות אחת ולהרחיב.',
            bullets: [
              'מניקור ופדיקור: טיפול ועיצוב ציפורניים',
              'הדבקת ריסים: Classic, Volume, Mega Volume',
              'עיצוב גבות: הדלדה, צביעה, Lamination',
              'ספרות גברים: תספורות, זקנים, Fades',
              'ספרות נשים: צביעה, החלקה, תספורות',
            ],
          },
          {
            id: 'certification',
            title: 'הסמכה ורישיון',
            body: 'חלק מהתחומים (ספרות) דורשים רישיון ממשרד הכלכלה. אחרים (מניקור, ריסים) לא דורשים רישיון אבל הסמכה מוכרת משפרת אמינות.',
            bullets: [
              'ספרות: דורש רישיון ממשרד הכלכלה',
              'מניקור / ריסים: אין חובת רישיון, אבל הסמכה עוזרת',
              'קורסים מוכרים מגבירים אמינות ללקוחות',
              'ביטוח מקצועי — חשוב לכל עוסק בטיפולים',
            ],
          },
          {
            id: 'business',
            title: 'לבנות עסק עצמאי',
            body: 'רוב בוגרי קורסי יופי עובדים עצמאית — בית, סטודיו קטן או בסלון. קורס טוב מלמד גם כיצד לשווק ולבנות בסיס לקוחות.',
            bullets: [
              'עבודה מהבית — מינימום השקעה',
              'שכירת עמדה בסלון',
              'פתיחת סטודיו עצמאי',
              'שיווק באינסטגרם לביוטישניות',
            ],
          },
        ],
        checklist: [
          'הקורס כולל תרגול על מודלים אמיתיים',
          'מספק ציוד / רשימת ציוד נדרש',
          'יש הסמכה מוכרת בסוף',
          'מכסה בטיחות וסניטציה',
          'יש ליווי בבניית פורטפוליו לאינסטגרם',
        ],
        redFlags: [
          'קורס קצר מדי (יומיים) לתחומים שדורשים שעות)',
          'ללא תרגול על מודלים אמיתיים',
          'אין הכשרה בבטיחות וסניטציה',
          'הבטחות "לקוחות מובטחים" מהקורס',
        ],
        faq: [
          { q: 'כמה מרוויחה ביוטישנית?', a: 'ביוטישנית עצמאית: 15,000–35,000₪. תלוי בהתמחות, מיקום ובסיס לקוחות. מניקוריסטית: 80–150₪ לטיפול.' },
          { q: 'האם צריך רישיון למניקור?', a: 'לא, מניקור לא דורש רישיון בישראל. ספרות כן דורשת רישיון ממשרד הכלכלה.' },
          { q: 'כמה זמן לוקח קורס מניקור?', a: 'קורס בסיסי: 2–4 שבועות. תכנית מקיפה עם כל הטכניקות: 2–3 חודשים.' },
        ],
      }}
    />
  );
}

// ════════════════════════════════════════
// app/courses/nutrition.tsx
// ════════════════════════════════════════
export function NutritionPage() {
  return (
    <CourseCategoryPage
      config={{
        title: 'קורס תזונה ובריאות',
        metaTitle: 'קורס תזונה 2025 – ייעוץ תזונתי, תזונת ספורט | Kursi',
        subtitle: 'ייעוץ תזונתי, תזונת ספורט ותזונה טבעית — מצאו קורס תזונה שמתאים למטרה שלכם.',
        chips: ['ייעוץ תזונתי', 'תזונת ספורט', 'תזונה טבעית', 'דיאטה', 'בריאות'],
        chatSeed: 'קורס תזונה',
        sections: [
          {
            id: 'types',
            title: 'איזה קורס תזונה מתאים לכם?',
            body: 'תזונה כוללת כמה מסלולים: ייעוץ תזונתי מקצועי, תזונת ספורטאים, תזונה טבעית ו-Holistic. כל מסלול שונה בעומק ובאפשרויות התעסוקה.',
            bullets: [
              'ייעוץ תזונתי: לעבודה עם לקוחות',
              'תזונת ספורט: לספורטאים ומאמנים',
              'תזונה טבעית / הוליסטית: גישה אינטגרטיבית',
              'מדעי התזונה: אקדמי, לתואר',
              'קורס תזונה אישי: לשיפור עצמי בלבד',
            ],
          },
          {
            id: 'regulation',
            title: 'מה מותר לדיאטנית ומה לא?',
            body: 'בישראל יש הבדל משפטי בין דיאטנית קלינית (תואר + רישיון) לבין יועצת תזונה (קורס). יועצת תזונה לא יכולה לטפל במצבים רפואיים.',
            bullets: [
              'דיאטנית קלינית: תואר אקדמי + רישיון — טיפול רפואי',
              'יועצת תזונה: קורס — הנחיה כללית בלבד',
              'אין לתת המלצות רפואיות ללא רישיון',
              'קורס טוב יסביר את גבולות הסמכות',
            ],
          },
          {
            id: 'practical',
            title: 'מעשי לעומת תיאורטי',
            body: 'קורס תזונה טוב לא רק מלמד נוטריינטים — הוא מלמד לבנות תפריטים, לעבוד עם לקוחות ולהתמודד עם אתגרים אמיתיים.',
            bullets: [
              'בניית תפריטים לסוגי לקוחות שונים',
              'עבודה עם לקוחות סימולציה',
              'ניתוח מקרים אמיתיים',
              'כיצד לנהל עסק ייעוץ תזונתי',
            ],
          },
        ],
        checklist: [
          'הקורס מסביר את גבולות הסמכות המקצועית',
          'יש תרגול עם בניית תפריטים',
          'המרצה עם הכשרה אקדמית בתזונה',
          'החומרים מעודכנים עם מחקרים עדכניים',
          'יש הסמכה מוכרת בסוף',
        ],
        redFlags: [
          'הבטחות "תרזה X ק"ג מובטח"',
          'קורס שמכריז על ריפוי מחלות',
          'אין הבחנה בין ייעוץ לטיפול רפואי',
          'חומרים על דיאטות אופנה ללא בסיס מדעי',
        ],
        faq: [
          { q: 'האם אפשר לעבוד כיועצת תזונה ללא תואר?', a: 'כן, ייעוץ תזונתי לא דורש תואר. אבל לא ניתן לטפל במצבים רפואיים ולהיקרא דיאטנית קלינית.' },
          { q: 'כמה מרוויחה יועצת תזונה?', a: 'ייעוץ פרטי: 200–450₪ לפגישה. עם 10–15 לקוחות שבועיים: 10,000–20,000₪ בחודש.' },
          { q: 'כמה זמן לוקח קורס ייעוץ תזונתי?', a: 'קורסים ממוקדים: 3–6 חודשים. תכניות מקיפות: 8–12 חודשים.' },
        ],
      }}
    />
  );
}

// ════════════════════════════════════════
// app/courses/cooking.tsx
// ════════════════════════════════════════
export function CookingPage() {
  return (
    <CourseCategoryPage
      config={{
        title: 'קורס בישול, קונדיטוריה ואפייה',
        metaTitle: 'קורס בישול וקונדיטוריה 2025 – מקצועי ואישי | Kursi',
        subtitle: 'בישול מקצועי, קונדיטוריה, אפייה ושוקולד — מצאו קורס שיהפוך אתכם לטבחים טובים יותר.',
        chips: ['בישול מקצועי', 'קונדיטוריה', 'אפייה', 'שוקולד', 'טבעוני', 'מאפים'],
        chatSeed: 'קורס בישול וקונדיטוריה',
        sections: [
          {
            id: 'goal',
            title: 'לבשל לכיף או לקריירה?',
            body: 'יש הבדל גדול בין קורסי בישול לתחביב לבין הכשרה מקצועית למסעדנות. הגדירו מטרה לפני שבוחרים.',
            bullets: [
              'תחביב: קורסים קצרים, טכניקות ספציפיות',
              'קריירה בישול: הכשרה מקצועית מלאה',
              'קונדיטוריה: עוגות, מאפים, שוקולד',
              'אפייה ביתית: לחם, מאפים, בריוש',
              'מיוחד: טבעוני, ללא גלוטן, אוכל בריא',
            ],
          },
          {
            id: 'professional',
            title: 'הכשרה מקצועית — מה כוללת?',
            body: 'הכשרה מקצועית למטבח כוללת טכניקות בסיסיות, היגיינת מזון, ניהול מטבח ועבודה תחת לחץ. קורסים מקצועיים מסתיימים עם תעודה מוכרת.',
            bullets: [
              'טכניקות בסיס: חיתוך, בישול, אפייה',
              'היגיינת מזון ובטיחות (חובה למסעדות)',
              'ניהול מטבח ועלויות',
              'תעודת תברואה — חובה לעוסקים במזון',
            ],
          },
          {
            id: 'business',
            title: 'להפוך את הבישול לעסק',
            body: 'הרבה בוגרים פותחים עסק עצמאי — קייטרינג, קורסי בישול, שף פרטי, דוכן שוק. קורס טוב מכין גם לצד העסקי.',
            bullets: [
              'קייטרינג — אירועים ומשפחות',
              'שף פרטי לבתים פרטיים',
              'הדרכת קורסי בישול עצמאית',
              'מאפייה / קונדיטוריה עצמאית',
            ],
          },
        ],
        checklist: [
          'יש עבודה מעשית במטבח (לא רק הדגמות)',
          'הקורס מכסה היגיינת מזון ובטיחות',
          'יש תעודה מוכרת בסוף',
          'המרצה עם ניסיון מטבח מקצועי',
          'הקורס מתאים לרמה שלי (מתחיל / מתקדם)',
        ],
        redFlags: [
          'קורס שרק צופים ואין בישול בפועל',
          'אין הכשרה בהיגיינת מזון',
          'מרצה ללא ניסיון במטבח מקצועי',
          'הבטחות "תהיה שף ב-2 שבועות"',
        ],
        faq: [
          { q: 'האם צריך תעודה לפתוח עסק מזון?', a: 'כן. תעודת תברואה (HACCP), אישור עסק ממשרד הבריאות — חובה. קורס מקצועי מכין לאלה.' },
          { q: 'כמה מרוויח שף פרטי?', a: 'שף פרטי לאירוע: 800–2,500₪. שף פרטי קבוע למשפחה: 5,000–15,000₪ בחודש.' },
          { q: 'מה ההבדל בין קונדיטוריה לאפייה?', a: 'קונדיטוריה: עוגות, מוס, שוקולד, קינוחים מורכבים. אפייה: לחם, מאפים, בצקים. חלק מהקורסים מכסים את שניהם.' },
        ],
      }}
    />
  );
}

// ════════════════════════════════════════
// app/courses/english.tsx
// ════════════════════════════════════════
export function EnglishPage() {
  return (
    <CourseCategoryPage
      config={{
        title: 'קורס אנגלית',
        metaTitle: 'קורס אנגלית 2025 – שיחה, עסקים, הייטק | Kursi',
        subtitle: 'אנגלית לשיחה, לעסקים, להייטק ולבגרות — מצאו קורס שיקפיץ את הרמה שלכם.',
        chips: ['שיחה', 'עסקים', 'הייטק', 'בגרות', 'IELTS', 'אמריקאי'],
        chatSeed: 'קורס אנגלית',
        sections: [
          {
            id: 'goal',
            title: 'לאיזה מטרה אתם צריכים אנגלית?',
            body: 'אנגלית זה לא קורס אחד. שיחה יומיומית, כתיבה עסקית, הכנה לבגרות, IELTS — כל מטרה דורשת גישה שונה.',
            bullets: [
              'שיחה יומיומית: ביטחון ושטף',
              'עסקים: כתיבה, מצגות, פגישות',
              'הייטק: אנגלית טכנית, קריאת דוקומנטציה',
              'בגרות: מבנה הבחינה, כתיבה, קריאה',
              'IELTS / TOEFL: לימודים בחו"ל',
            ],
          },
          {
            id: 'method',
            title: 'איזו שיטת לימוד עובדת?',
            body: 'שיטת הלימוד חשובה לא פחות מהמרצה. שיחה מרובה, חשיפה לתוכן אנגלי אמיתי ותרגול יומיומי — אלה מה שמביא לתוצאות.',
            bullets: [
              'שיחה מרובה: דיבור מהיום הראשון',
              'חשיפה: פילמים, פודקאסטים, ספרים',
              'תרגול יומיומי: אפילו 20 דקות ביום',
              'משוב על שגיאות: לא רק "כל הכבוד"',
            ],
          },
          {
            id: 'levels',
            title: 'רמות ומסלולים',
            body: 'חשוב לבחור קורס ברמה הנכונה. קורס קל מדי — משעמם ולא מתקדמים. קורס קשה מדי — מתבאסים. בדקו שיש בדיקת רמה לפני הקורס.',
            bullets: [
              'Beginner: A1–A2 — יסודות הבסיס',
              'Intermediate: B1–B2 — הרמה הנפוצה',
              'Advanced: C1–C2 — שליטה מלאה',
              'Business English: לכל הרמות עם פוקוס עסקי',
            ],
          },
        ],
        checklist: [
          'יש בדיקת רמה לפני הקורס',
          'יש הרבה זמן דיבור ולא רק הסברים',
          'המרצה דובר שפת אם או בעל מבטא ניטרלי',
          'הקורס מכוון למטרה הספציפית שלי',
          'יש חומרי תרגול לאחר השיעורים',
        ],
        redFlags: [
          'הבטחות "תדבר אנגלית ב-30 יום" ללא תרגול',
          'שיעורים בעברית בלבד ללא דיבור אנגלית',
          'אין בדיקת רמה — כולם באותה קבוצה',
          'מרצה ללא הכשרה בהוראת שפה',
        ],
        faq: [
          { q: 'כמה זמן לוקח ללמוד אנגלית?', a: 'מ-A0 לB2 (רמה בינונית): בממוצע 600–750 שעות לימוד. עם 1 שעה ביום: כ-2 שנים. עם 2–3 שעות: כשנה.' },
          { q: 'האם כדאי מורה פרטי או קורס קבוצתי?', a: 'שניהם. קבוצתי: זול יותר, חשיפה לדוברים שונים. פרטי: מהיר יותר, ממוקד בצרכים שלך. שילוב אידיאלי.' },
          { q: 'מה עדיף — אמריקאי או בריטי?', a: 'בישראל ובהייטק — אמריקאי נפוץ יותר. לבגרות — שניהם מקובלים. IELTS — בריטי.' },
        ],
      }}
    />
  );
}